module.exports = __webpack_public_path__ + "assets/img/6a8809434875bcf37b076136a192e301.svg";